import { useContext } from "react";
import TenantDocumentListsContext from "../context/tenantDocumentLists/TenantDocumentListsContext";

// { status: "loading" | "ready" | "error", lists, retry }
export const useTenantDocumentListsStatus = () => {
  const context = useContext(TenantDocumentListsContext);
  if (!context) {
    throw new Error(
      "useTenantDocumentLists must be used inside TenantDocumentListsState"
    );
  }
  return context;
};

// Usage (inside TenantDocumentListsGate / withTenantDocumentLists):
//   const { docsMap, forensic_docs_map, dea_missing_docs } =
//     useTenantDocumentLists();
// Throws when the lists are not loaded yet, so a component never works with
// empty lists by mistake.
const useTenantDocumentLists = () => {
  const { status, lists } = useTenantDocumentListsStatus();
  if (status !== "ready" || !lists) {
    throw new Error(
      "Tenant document lists are not loaded yet: render inside TenantDocumentListsGate"
    );
  }
  return lists;
};

export default useTenantDocumentLists;
